import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/consultas",
    name: "Consultas",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/Consultas.vue"),
  },
  {
    path: "/metaslojistas",
    name: "MetasLojistas",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/MetasLojistas.vue"),
  },
]